import React, { FC, useContext, useEffect } from 'react';
import { Question } from '@ch/common/types/data';
import { FormSelect } from '@ch/common/components/form/select';
import { useDropdown } from './hooks/use-dropdown';
import { AppContext } from '../app-context';
import { preloadDropdownData } from './helpers/dropdown-options';

const QuizFieldDropdown: FC<Question> = ({
  identifier: name,
  disabled,
  value,
  placeholder,
  sortStrategy,
  file = '',
}) => {
  const { options, onFocus, isLoading } = useDropdown({ file, sortStrategy });
  const { dropdownData, setDropdownData } = useContext(AppContext);

  useEffect(() => {
    if (value && file && !dropdownData[file]) {
      preloadDropdownData({
        externalOptionFiles: [file],
        dropdownData,
        sortStrategy,
        callback: setDropdownData,
      });
    }
  });

  return (
    <FormSelect
      {...{
        name,
        options: options,
        hideError: true,
        value,
        onFocus: () => onFocus(),
        isLoading,
        placeholder,
        disabled,
      }}
    />
  );
};

export default QuizFieldDropdown;
